import {useRequirementValue} from '@yandex-taxi/react-integration-api'
import {useEffect} from 'react'
import {useHistory, useLocation} from 'react-router-dom'

import {useConfig} from 'src/config'

import {cargoTypeIntRequirementsToUrl, cargoTypeRequirementsToUrl} from '../../../consts'

export const useUpdateURLPath = (tariff: string, cargoTypeRequirementName?: string) => {
  const {push} = useHistory()
  const {pathname} = useLocation()
  const tariffOrCargoRequirement = pathname.split('/').filter(Boolean).pop()
  const isPathNameChanged =
    tariffOrCargoRequirement !== tariff ||
    (cargoTypeRequirementName && tariffOrCargoRequirement !== cargoTypeRequirementName)
  const config = useConfig()
  const [{value: cargoType}] = useRequirementValue(cargoTypeRequirementName)
  const path = isPathNameChanged
    ? [
        config.initialProps.zoneName,
        tariff,
        tariff === 'cargo' &&
          cargoType &&
          (cargoTypeIntRequirementsToUrl[String(cargoType)] || cargoTypeRequirementsToUrl[String(cargoType)]),
      ]
        .filter(chunk => {
          return Boolean(chunk) && chunk !== 'small-van'
        })
        .join('/')
    : undefined

  useEffect(() => {
    path && push(`/${path}/`)
  }, [path, push])
}
